var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[(_vm.loading)?_c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"loading-center"}),_c('span',[_vm._v("Loading..")])]):_c('img',{attrs:{"src":"/images/openimagehealth/example/content.png"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }